import { projectNamespace } from "@droid/project-v2-interface"

export const triggerActionsNamespace = `${projectNamespace}triggerActions/`
